import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../static/home/image/10th_wide.png'
import _imports_1 from '../static/home/image/10th_rectangle_mini.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = { class: "home-width" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "lottie-box" }
const _hoisted_7 = { class: "guide" }
const _hoisted_8 = { class: "home-title" }
const _hoisted_9 = { class: "home-sub-title" }
const _hoisted_10 = { class: "guide-bg" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "btn-group flex justify-space-between" }
const _hoisted_13 = { class: "case" }
const _hoisted_14 = { class: "home-title" }
const _hoisted_15 = { class: "home-sub-title" }
const _hoisted_16 = { class: "carousel home-width" }
const _hoisted_17 = { class: "carousel-box" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "case-image-box" }
const _hoisted_20 = ["src"]
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "company" }
const _hoisted_23 = { class: "flex justify-center" }
const _hoisted_24 = { class: "qa" }
const _hoisted_25 = { class: "home-title" }
const _hoisted_26 = { class: "home-sub-title" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "item" }
const _hoisted_29 = { class: "ques" }
const _hoisted_30 = { class: "tag" }
const _hoisted_31 = { class: "flex justify-center margin-top-64" }
const _hoisted_32 = { class: "note" }
const _hoisted_33 = { class: "home-title" }
const _hoisted_34 = { class: "time-tag flex align-center" }
const _hoisted_35 = { class: "time align-center justify-center" }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { class: "flex justify-center margin-top-64" }

import { computed, onMounted, onUnmounted, ref } from "vue";
import SafieButton from "@/common/components/SafieButton.vue";
import staticData from "@/static/index";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useStore } from "@/store";
import { ICaseStudy } from "@/static/dataType";
import axios from "axios";
import lottie, { AnimationItem } from "lottie-web";
import lottieData from "@/static/home/data.json";
const caseBaseRoute = "/casestudy/";
interface IFaqItem {
  category1: string;
  answer: string;
  question: string;
  category2: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const lottieRef = ref();

const lottieContext = ref<AnimationItem>();
onMounted(() => {
  lottieContext.value = lottie.loadAnimation({
    container: lottieRef.value,
    autoplay: true,
    animationData: lottieData,
  });
});

onUnmounted(() => {
  lottieContext.value && lottieContext.value.destroy();
});

const { t } = useI18n();
const router = useRouter();
const currenCase = ref(0);
const store = useStore();
const isLogin = computed(() => store.state.isLogin);
const handleChangeCase = (type: string) => {
  if (type === "prev") {
    if (currenCase.value === 0) return false;
    currenCase.value = currenCase.value - 1;
  } else if (type === "next") {
    if (currenCase.value === 3) return false;
    currenCase.value = currenCase.value + 1;
  }
};

const handlerQaItem = (index: number) => {
  let copyPathId = "";
  switch (index) {
    case 0:
      copyPathId = "0-0-0";
      break;
    case 1:
      copyPathId = "1-0-0";
      break;
    case 2:
      copyPathId = "2-0-0";
      break;
    case 3:
      copyPathId = "3-0-0";
      break;
  }
  router.push({
    path: "/faq",
    query: {
      path: copyPathId,
    },
  });
};

const caseData = ref<ICaseStudy[]>();
axios.get("./static/case.json").then((res) => {
  caseData.value = res.data as ICaseStudy[];
});
const faqData = ref();
axios.get("./static/faq.json").then((res) => {
  faqData.value = res.data;
});
const faqShowData = computed(() => {
  const result: IFaqItem[] = [];
  if (faqData.value) {
    const category1 = faqData.value.category1;
    category1.forEach((category: string) => {
      const faqItem = faqData.value.data.find(
        (item: { category1: string }) => item.category1 === category,
      );
      faqItem && result.push(faqItem);
    });
  }
  return result;
});
const releaseData = ref();
axios.get("./static/release.json").then((res) => {
  releaseData.value = res.data;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(staticData).home.banner.title), 1),
        _createElementVNode("div", {
          class: "des",
          innerHTML: _unref(staticData).home.banner.des
        }, null, 8, _hoisted_5),
        (!isLogin.value)
          ? (_openBlock(), _createBlock(SafieButton, {
              key: 0,
              type: "second",
              size: "large-52",
              width: 240,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(_unref(staticData).home.banner.btn.router)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(staticData).home.banner.btn.text), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "down",
          ref_key: "lottieRef",
          ref: lottieRef
        }, null, 512)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(staticData).home.guide.title), 1),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(staticData).home.guide.subTitle), 1),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("img", {
          src: _unref(staticData).home.guide.img
        }, null, 8, _hoisted_11),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(SafieButton, {
            size: "large-52",
            width: 240,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push(_unref(staticData).home.guide.methodBtn.router)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(staticData).home.guide.methodBtn.text), 1)
            ]),
            _: 1
          }),
          _createVNode(SafieButton, {
            size: "large-52",
            width: 240,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push(_unref(staticData).home.guide.guideBtn.router)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(staticData).home.guide.guideBtn.text), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(staticData).home.case.title), 1),
      _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(staticData).home.case.subTitle), 1),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", {
          class: "prev Safieicon",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (handleChangeCase('prev')))
        }, "  "),
        _createElementVNode("div", {
          class: "next Safieicon",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (handleChangeCase('next')))
        }, "  "),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", {
            class: "flex",
            style: _normalizeStyle({ left: `-${currenCase.value * 386}px`, transition: 'left 1s' })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(caseData.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "box",
                key: index,
                onClick: ($event: any) => (_unref(router).push(caseBaseRoute + item.id))
              }, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("img", {
                    src: item.home_image
                  }, null, 8, _hoisted_20),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "image-hover-mask" }, null, -1))
                ]),
                _createElementVNode("div", {
                  class: "title",
                  innerHTML: item.title
                }, null, 8, _hoisted_21),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.apis, (tag, tagIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "tag",
                    key: tagIndex
                  }, _toDisplayString(tag), 1))
                }), 128)),
                _createElementVNode("div", _hoisted_22, _toDisplayString(item.company.info[0].name) + _toDisplayString(_unref(t)("global.COMPANY_NAME_SUFFIX")), 1)
              ], 8, _hoisted_18))
            }), 128))
          ], 4)
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(SafieButton, {
          size: "large-52",
          width: 240,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push(_unref(staticData).home.case.btn.router)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(staticData).home.case.btn.text), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(staticData).home.qa.title), 1),
      _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(staticData).home.qa.subTitle), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faqShowData.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "qa-item flex justify-space-between home-width align-center",
          key: index,
          onClick: ($event: any) => (handlerQaItem(index))
        }, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, _toDisplayString(item.question), 1),
            _createElementVNode("div", _hoisted_30, _toDisplayString(item.category1) + _toDisplayString(_unref(t)("global.HOME_FAQ_STATUS_SUFFIX")), 1)
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "Safieicon" }, "", -1))
        ], 8, _hoisted_27))
      }), 128)),
      _createElementVNode("div", _hoisted_31, [
        _createVNode(SafieButton, {
          size: "large-52",
          width: 240,
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(router).push(_unref(staticData).home.qa.btn.router)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(staticData).home.qa.btn.text), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(staticData).home.note.title), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(releaseData.value?.slice(0, 3), (listItem, listIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: listIndex,
          class: "note-item home-width"
        }, [
          _createElementVNode("div", _hoisted_34, [
            _cache[10] || (_cache[10] = _createElementVNode("span", null, null, -1)),
            _createElementVNode("div", _hoisted_35, _toDisplayString(listItem.release_date), 1)
          ]),
          _createElementVNode("div", {
            innerHTML: listItem.note
          }, null, 8, _hoisted_36),
          _cache[11] || (_cache[11] = _createElementVNode("div", null, null, -1))
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_37, [
        _createVNode(SafieButton, {
          size: "large-52",
          width: 240,
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(router).push(_unref(staticData).home.note.btn.router)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(staticData).home.note.btn.text), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"banner-10th\" data-v-452ef004><a href=\"https://safie.co.jp/10th/\" target=\"_blank\" data-v-452ef004><div class=\"pc\" data-v-452ef004><img src=\"" + _imports_0 + "\" data-v-452ef004></div><div class=\"sp\" data-v-452ef004><img src=\"" + _imports_1 + "\" data-v-452ef004></div></a></div>", 1))
  ]))
}
}

})